export default "__VITE_ASSET__tj_$BntM__"